<app-navbar></app-navbar>

<router-outlet></router-outlet>

<app-footer></app-footer>
<app-token-expired *ngIf="expired"></app-token-expired>
<app-internal-server-error *ngIf="error" [errorData]="errorData.error" (cerrar)="error = false"></app-internal-server-error>